import React from 'react';

type Props = {
  children: React.ReactNode;
};

type State = {
  error: Error | null;
};

const pageFrameStyle: React.CSSProperties = {
  minHeight: '100vh',
  padding: 24,
  background: '#f5f7fb',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const errorCardStyle: React.CSSProperties = {
  width: '100%',
  maxWidth: 720,
  borderRadius: 16,
  boxShadow: '0 20px 48px rgba(15, 23, 42, 0.08)',
  background: '#fff',
  padding: 32,
};

const reloadButtonStyle: React.CSSProperties = {
  height: 40,
  borderRadius: 8,
  border: '1px solid #1677ff',
  background: '#1677ff',
  color: '#fff',
  padding: '0 16px',
  cursor: 'pointer',
};

class GlobalErrorBoundary extends React.Component<Props, State> {
  state: State = {
    error: null,
  };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // Keep the browser console useful when a local tenant page crashes.
    // eslint-disable-next-line no-console
    console.error('GlobalErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (!this.state.error) {
      return this.props.children;
    }

    return (
      <div style={pageFrameStyle}>
        <section style={errorCardStyle}>
          <h1 style={{ margin: '0 0 12px', fontSize: 24, color: '#0f172a' }}>
            页面渲染失败
          </h1>
          <p style={{ margin: '0 0 20px', color: '#64748b' }}>
            前端在渲染当前页面时抛出了未捕获异常。
          </p>
          <button type="button" style={reloadButtonStyle} onClick={() => window.location.reload()}>
            重新加载
          </button>
          <p style={{ margin: '20px 0 0', color: '#64748b' }}>
            {this.state.error.message || '未知错误'}
          </p>
        </section>
      </div>
    );
  }
}

export default GlobalErrorBoundary;
